import { makeObservable, observable } from 'mobx';
import moment from 'moment';

export class KvAgtMsModel {
	constructor(opts: any) {
		makeObservable(this);
		this.id = opts.id;
		this.agtId = opts.aid;
		this.bnrId = opts.bnrId;
		this.bm = opts.bm;
		this.group = opts.group;
		this.key = opts.key;
		this.key2 = opts.key2;
		if (opts.n) {
			this.valueNum = opts.n;
		}

		if (opts.s) {
			this.valueString = opts.s;
		}

		if (opts.j) {
			this.valueJson = opts.j;
		}

		this.modified = new Date(opts.modified);
	}

	agtId: number;
	bnrId: number;
	bm: number;

	group: string;
	id: string;
	key: string;
	key2: string;

	@observable
	valueNum: number = 0;

	@observable
	valueString: string = '';

	@observable
	valueJson?: string = undefined;

	modified: Date;

	static getString = (items: KvAgtMsModel[], key: string): string | undefined => {
		const item = items.find((i) => i.key === key);
		if (item) {
			return item.valueString;
		}
	};
	static getNumber = (items: KvAgtMsModel[], key: string): number | undefined => {
		const item = items.find((i) => i.key === key);
		if (item) {
			return item.valueNum;
		}
	};
	static getDate = (items: KvAgtMsModel[], key: string): Date | undefined => {
		const item = items.find((i) => i.key === key);
		if (item && item.valueNum) {
			return moment(item.valueNum).toDate();
		}
	};
}
